import { type AvatarBehavior } from '@/shared/features/user-avatar';
import { cn } from '@/utils';
const MOTION_OPTIONS: AvatarBehavior[] = ['stand', 'walk', 'dance'];

// 코어 AvatarMotionButton 과 동일한 webp 에셋 (public/play/avatarMotion).
const MOTION_IMAGE_MAP: Record<AvatarBehavior, {
  default: string;
  active: string;
}> = {
  stand: {
    default: '/play/avatarMotion/stand.webp',
    active: '/play/avatarMotion/stand_colored.webp'
  },
  walk: {
    default: '/play/avatarMotion/walk.webp',
    active: '/play/avatarMotion/walk_colored.webp'
  },
  dance: {
    default: '/play/avatarMotion/dance.webp',
    active: '/play/avatarMotion/dance_color.webp'
  }
};
export const AvatarMotionToggle = ({
  selectedMotion,
  onMotionChange
}: {
  selectedMotion: AvatarBehavior;
  onMotionChange: (motion: AvatarBehavior) => void;
}) => {
  return <div className="flex w-fit items-center rounded-[99px] border border-black/[0.04] bg-gray-50 p-4xs" data-sentry-component="AvatarMotionToggle" data-sentry-source-file="AvatarMotionToggle.tsx">
      {MOTION_OPTIONS.map(motion => {
      const isActive = selectedMotion === motion;
      const images = MOTION_IMAGE_MAP[motion];
      return <button key={motion} type="button" onClick={() => onMotionChange(motion)} aria-label={motion} className={cn('py-3xs px-md flex shrink-0 cursor-pointer items-center justify-center rounded-[999px] border-2', isActive ? 'border-violet-300 bg-violet-50 shadow-sm' : 'border-transparent bg-transparent hover:bg-gray-200')}>
            <div className="relative h-[30px] w-[24.75px] overflow-hidden">
              <img src={isActive ? images.active : images.default} alt={motion} className="absolute inset-0 size-full object-cover object-center" />
            </div>
          </button>;
    })}
    </div>;
};